import React from "react";
import { MediaMuteButton, MediaVolumeRange } from "media-chrome/react";
import { MuteIcon, VolumeHighIcon, VolumeLowIcon } from "assets";
import "./index.scss";

const VolumeControl = () => {
  return (
    <div className="volume-control">
      <MediaMuteButton className="bg-transparent p-0">
        <span slot="high">
          <VolumeHighIcon width={20} height={20} />
        </span>
        <span slot="medium">
          <VolumeLowIcon width={20} height={20} />
        </span>
        <span slot="low">
          <VolumeLowIcon width={20} height={20} />
        </span>
        <span slot="off">
          <MuteIcon width={20} height={20} />
        </span>
      </MediaMuteButton>
      <MediaVolumeRange className="volume-range" />
    </div>
  );
};

export default VolumeControl;
